import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import ResultForm from './ResultForm';

storiesOf('Advanced Search/Result Form', module)
  .add('View', () => (
    <ResultForm
      filter={{court_type: 'bankruptcy', tab: 'schedules'}}
      onSubmit={action('searchGeneral')}
      onReset={action('resetGeneralSearch')}
    />
  ));



// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/ResultForm.stories.jsx